<template>
  <div :class="$style.select">
    <div @click="select" :class="$style.selectWrap">
      <span>{{ label }}</span>
      <span>{{selectVal || ''}}</span>
      <i class="iconfont yw-shixinjiantou-xiangshang-copy"></i>
    </div>
    <ul :class="`${$style.drop} ${active && $style.active} yw-select-drop`">
      <li 
        v-for="(item, index) in options" 
        :key="index" 
        @click="change(item)"
        :class="`${value === item.value}`"
      >{{item.text}}</li>
      <span v-if="!options.length">{{ hint }}</span>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: ""
    },
    options: {
      default: () => []
    },
    placeholder: {
      default:""
    },
    hint: {
      default: ""
    },
    label: {
      default:""
    },
  },
  data () {
    return {
      active: false
    };
  },
  components: {
    
  },
  computed: {
    selectVal() {
      const val = this.options.find(item => item.value === this.value)
      return (val && val.text) || this.value
    }
  },
  methods: {
    select() {
      this.active = !this.active;
      this.$emit('select', this.active)
    },
    change(item) {
      this.$emit('change', item);
      this.active = !this.active;
    },
    reset() {
      this.active = false;
    }
  }
}
</script>

<style lang="scss" module>
.select {
  position: relative;
  width: 225.69px;
  margin: auto;
  .selectWrap {
    > span:nth-child(2) {
      color: #7c7c7c;
    }
  }
  > div:nth-child(1) {
    background: #f2f2f2;
    border-radius: 17.36px;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #CDCDCD;
    margin: auto {
      bottom: 8px;
    };
    :global {
      .yw-shixinjiantou-xiangshang-copy {
        color: #CACACA;
      }
    }
    > span {
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
  }
  .drop {
    position: absolute;
    top: 36px;
    z-index: 10;
    background-color: #f2f2f2;
    color: #838080;
    width: 100%;
    border-radius: 6px;
    // display: none;
    height: 0;
    transition: height 0.2s ease-out;
    box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    overflow-y: auto;
    > span {
      display: inline-block;
      width:100%;
      padding: 10px;
      color: #CDCDCD;
      text-align: center;
    }
    &.active {
      // display: block;
      height: 100px;
    }
    > li {
      text-align: center;
      padding: 10px;
      position: relative;
      &:active {
        background-color: #d0d1d3;
      }
      &.active {
        color: #FF9600;
      }
      &:after {
        position: absolute;
        content: ' ';
        pointer-events: none;
        right: 0;
        bottom: 0;
        left: 0;
        border-bottom: 1px solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
      }
    }
  }
}
</style>